export default "__VITE_ASSET__DJgHbWv___"